import AuthorizationDetails from './AuthorizationDetails';

export default AuthorizationDetails;
